import { Box, Flex, Progress, Text } from "@chakra-ui/react";
import { Dropdown, Menu } from "antd";
import { CentroDeCustoResponse } from "core/features/centro-de-custo/typings";
import { showConfirm, showErrorAxios } from "infra/helpers/alerta";
import { formatMoney } from "infra/helpers/number";
import { useState } from "react";
import { FaEllipsisV } from "react-icons/fa";
import CardDefault from "ui/components/Cards/CardDefault";
import useDeleteCentroDeCusto from "core/features/centro-de-custo/hooks/useDeleteContaBancaria";

export default function CentroDeCustoItem({
  centroDeCusto,
  tenant,
  onRefresh,
  onEdit,
}: {
  centroDeCusto: CentroDeCustoResponse;
  tenant: string;
  onRefresh: () => void;
  onEdit: () => void;
}) {
  const [containerRef, setContainerRef] = useState<any>();

  const { mutate: handleDelete, isLoading: isLoadingDelete } =
    useDeleteCentroDeCusto(tenant);

  const menu = (
    <Menu>
      <Menu.Item onClick={() => onEdit()}>Editar</Menu.Item>
      <Menu.Item
        onClick={() =>
          showConfirm().then(({ isConfirmed }) => {
            if (isConfirmed) {
              handleDelete(centroDeCusto.id, {
                onSuccess: () => {
                  onRefresh();
                },
                onError: (err: unknown) => {
                  showErrorAxios(err);
                },
              });
            }
          })
        }
      >
        Excluir
      </Menu.Item>
    </Menu>
  );

  return (
    <CardDefault p="12px">
      {isLoadingDelete ? (
        <Progress
          size="sm"
          isIndeterminate
          w="100%"
          mb={4}
          colorScheme="cyan"
        />
      ) : null}
      <Flex gap="8px" ref={setContainerRef}>
        <Flex flex={1} flexDirection="column">
          <Box
            w={`calc(${(containerRef?.clientWidth ?? 0) - 70}px)`}
            title={centroDeCusto.nome}
          >
            <Text whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
              {centroDeCusto.nome}
            </Text>
          </Box>
        </Flex>

        <Dropdown trigger={["click"]} overlay={menu} arrow>
          <Flex cursor="pointer" alignItems="center">
            <FaEllipsisV color="#555" />
          </Flex>
        </Dropdown>
      </Flex>

      <Flex mx="-12px" px="12px" pt="8px" mt="16px" borderTop="1px solid #eee">
        <Flex color="gray.500">Saldo</Flex>
        <Flex
          flex={1}
          color={
            centroDeCusto.saldo < 0
              ? "red"
              : centroDeCusto.saldo > 0
              ? "green"
              : "gray.700"
          }
          justifyContent="flex-end"
        >
          {formatMoney(Number(centroDeCusto.saldo))}
        </Flex>
      </Flex>
    </CardDefault>
  );
}
